import { mapValues } from 'lodash';

/**
 * Given an object, recursively construct a string representation of the
 * key(s) as the value.
 *
 * @param {Object} obj - The object to map
 * @param {String} prefix - A string prefix to prepend to the current value,
 * recursively this is set to previous key constructed up to that depth.
 *
 * @returns {Object} - A new object, whose values are assigned to represent the keys at any depth (see example below).
 *
 * @example
 *
 * const obj = {
 *   foo: '',
 *   bar: {
 *     hello: '',
 *     world: '',
 *     fizz: {
 *       buzz: ''
 *     }
 *   }
 * }
 *
 * const result = objectKeyToString(obj);
 *
 * // Output of result
 * result = {
 *   foo: 'foo',
 *   bar: {
 *     hello: 'bar.hello',
 *     world: 'bar.world',
 *     fizz: {
 *       buzz: 'bar.fizz.buzz'
 *     }
 *   }
 * }
 **/
const objectKeyToString = (obj, prefix) =>
  mapValues(obj, (v, k) => {
    const key = (prefix ? prefix + '.' : '') + k;
    return typeof v === 'object' ? objectKeyToString(v, key) : key;
  });

export default objectKeyToString;
export { objectKeyToString };
